import { render, staticRenderFns } from "./ProductTab.vue?vue&type=template&id=5f5edcba&scoped=true&lang=pug"
import script from "./ProductTab.vue?vue&type=script&lang=js"
export * from "./ProductTab.vue?vue&type=script&lang=js"
import style0 from "./ProductTab.vue?vue&type=style&index=0&id=5f5edcba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5edcba",
  null
  
)

export default component.exports